import { onMounted, onUnmounted, readonly, ref, type Ref } from 'vue'

interface FrontendVersion {
  readonly sha: Readonly<Ref<string | null>>
  readonly isLoading: Readonly<Ref<boolean>>
}

function readConsoleSha(value: unknown): string | null {
  if (typeof value !== 'object' || value === null) return null
  const stamp = value as Record<string, unknown>
  if (stamp['surface'] !== 'console' || typeof stamp['sha'] !== 'string' || !/^[a-f0-9]{40}$/i.test(stamp['sha'])) return null
  if (typeof stamp['builtAt'] !== 'string' || !Number.isFinite(Date.parse(stamp['builtAt']))) return null
  if (typeof stamp['ref'] !== 'string' || !stamp['ref'].trim()) return null
  return stamp['sha']
}

export function useFrontendVersion(): FrontendVersion {
  const sha = ref<string | null>(null)
  const isLoading = ref(true)
  const controller = new AbortController()

  onMounted(async () => {
    try {
      // Damga SPA dağıtımına aittir; BFF istemcisinin baseUrl'ine gitmez.
      // İstemci önbelleğini ve başka origin'e yönlendirmeyi kullanmayız.
      const response = await fetch('/version.json', {
        cache: 'no-store', credentials: 'same-origin', redirect: 'error', signal: controller.signal,
      })
      const value: unknown = response.ok ? await response.json() : null
      if (!controller.signal.aborted) sha.value = readConsoleSha(value)
    } catch {
      if (!controller.signal.aborted) sha.value = null
    } finally {
      if (!controller.signal.aborted) isLoading.value = false
    }
  })
  onUnmounted(() => controller.abort())

  return { sha: readonly(sha), isLoading: readonly(isLoading) }
}
